import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddDesmotadora = ({setIsLoggedIn}) => {

    const URL_ADD = `${process.env.REACT_APP_API_BASE}/desmotadoras/Add`
    
    const token = localStorage.getItem('token')

    let navigate = useNavigate();

    const [desmotadora, setDesmotadora] = useState({
        codigoDesmotadora: "",
        nombre: ""
    });

    const [message, setMessage] = useState("");

    const {codigoDesmotadora, nombre} = desmotadora;

    const OnInputChange = (e) => {
        setDesmotadora({...desmotadora, [e.target.name]: e.target.value});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const response = await fetch(`${URL_ADD}`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "Application/json"
            },
            body: JSON.stringify(desmotadora)
        });

        if(!response.ok){
            setMessage("No se guardó el registro");
        }else {
            navigate("/desmotadoras");
        }
    }

    const handleGoBack = () => {
        setIsLoggedIn(true);
        navigate('/desmotadoras');
    }

    return (
        <div className='container'>
            <form className="form" onSubmit={(e) => onSubmit(e)}>
                <div>
                    <h3>Agregar Desmotadora</h3>
                    <label htmlFor="codigoDesmotadora">Código</label>
                    <input
                        type="text"
                        className="controls"
                        id="codigoDesmotadora"
                        name="codigoDesmotadora"
                        placeholder="Código Desmotadora"
                        required={true}
                        value={codigoDesmotadora}
                        autoComplete='off'
                        onChange={(e) => OnInputChange(e)}
                    />

                    <label htmlFor="nombre">Descripción</label>
                    <input
                        type="text"
                        className="controls"
                        id="nombre"
                        name="nombre"
                        placeholder="Nombre Desmotadora"
                        required={true}
                        value={nombre}
                        autoComplete='off'
                        onChange={(e) => OnInputChange(e)}
                    />
                </div>

                <div className="content-form-buttons">
                    <button
                        className="btn btn-add"
                        type="submit"
                    >
                        Agregar
                    </button>
                    <button className="btn btn-delete" onClick={handleGoBack}>
                        Regresar
                    </button>
                </div>
             </form>
        </div>
    );

    
}

export default AddDesmotadora;
